import AssignedReferrers from "./AssignedReferrers";

export default AssignedReferrers